import { render, staticRenderFns } from "./TargetDuplicateSettings.vue?vue&type=template&id=47253274"
import script from "./TargetDuplicateSettings.vue?vue&type=script&lang=js"
export * from "./TargetDuplicateSettings.vue?vue&type=script&lang=js"
import style0 from "./TargetDuplicateSettings.vue?vue&type=style&index=0&id=47253274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports